import React, { useEffect, useState } from "react";
import { AccountBody, AccountContainer, AccountItem } from "./DeviceAccountManagement.styles";
import UI from "@mile-meeting/mile-ui";
import { useRecoilValue } from "recoil";
import { member } from "recoil/recoilState";
import { UserRole } from "utils/role";
import { getWorkspacesTabletAccount, TTabletAccount, updateWorkspacesTabletAccount } from "apis/workspace/tablet-code";
import { useToast } from "hook/useToast";
import ChangeDeviceAccountModal from "./ChangeDeviceAccountModal";
import Callout from "uis/Callout";

type TDeviceAccountManagementProps = {
  isShow?: boolean;
};
const DeviceAccountManagement: React.FC<TDeviceAccountManagementProps> = ({ isShow = false }) => {
  const memberInfo = useRecoilValue(member);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [tabletAccount, setTabletAccount] = useState<TTabletAccount>();
  const [isConflictError, setIsConflictError] = useState<boolean>(false);
  const { showToast } = useToast();

  const onHandleChangeAccount = () => {
    setOpenModal(true);
  };

  const getTabletAccount = () => {
    getWorkspacesTabletAccount().then((res) => {
      if (res.success) {
        setTabletAccount({
          tabletAccountId: res.data?.tabletAccountId ?? "",
          tabletAccountPassword: res.data?.tabletAccountPassword ?? "",
        });
      }
    });
  };

  const onChangeAccount = async (updateTabletAccount: TTabletAccount) => {
    if (JSON.stringify(tabletAccount) === JSON.stringify(updateTabletAccount)) {
      setOpenModal(false);
      return;
    }

    const res = await updateWorkspacesTabletAccount(updateTabletAccount);
    if (res.success) {
      setOpenModal(false);
      setIsConflictError(false);
      showToast("기기 로그인 계정 정보를 변경했습니다.", "success");
      getTabletAccount();
    } else {
      if (res.statusCode === 409) {
        setIsConflictError(true);
      } else {
        showToast(res.message ?? "기기 로그인 계정 정보 변경에 실패했습니다. 다시 시도해 주세요.", "error");
      }
    }
  };

  useEffect(() => {
    if (!isShow) return;
    getTabletAccount();
  }, [isShow]);

  if (!isShow) return null;

  return (
    <AccountContainer>
      <Callout context="회의실 기기(태블릿) 로그인 시 사용되는 계정 정보입니다." />
      <AccountBody>
        <AccountItem>
          <UI.Typography
            style={{ width: "80px" }}
            type="body01 normal"
            fontStyle="bold"
            color="var(--alias-color-label-alternative"
          >
            아이디
          </UI.Typography>
          <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-normal)">
            {tabletAccount?.tabletAccountId ?? ""}
          </UI.Typography>
        </AccountItem>
        <AccountItem style={{ borderTop: "1px solid var(--alias-color-line-normal) " }}>
          <UI.Typography
            style={{ width: "80px" }}
            type="body01 normal"
            fontStyle="bold"
            color="var(--alias-color-label-alternative"
          >
            비밀번호
          </UI.Typography>
          <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-normal)">
            {tabletAccount?.tabletAccountPassword ?? ""}
          </UI.Typography>
        </AccountItem>
      </AccountBody>
      {memberInfo && memberInfo.role < UserRole.PolicyAdmin && (
        <div style={{ alignSelf: "flex-end" }}>
          <UI.Button title="변경하기" primary={false} onClick={onHandleChangeAccount} />
        </div>
      )}
      <ChangeDeviceAccountModal
        tabletAccount={tabletAccount}
        modalIsOpen={openModal}
        onChange={onChangeAccount}
        closeModal={() => setOpenModal(false)}
        isConflictError={isConflictError}
      />
    </AccountContainer>
  );
};

export default React.memo(DeviceAccountManagement);
